import type { ReadonlyNonEmptyArray } from '../../utils'

import type { TopicTree } from '.'
import type { Loadable } from '../Loadable'

type Topic = Readonly<{ fullPath: string, name: string, hasChildren: boolean }>

/**
 * The metadata that will be used to load the next chunk
 */
export type TopicsNextChunkMetadata = Readonly<{ reference: string, pageSize: number }>

export type TopicsChunk = Readonly<{ topics: readonly Topic[], nextChunk: TopicsNextChunkMetadata | null }>

export type LoadableTopicsChunk = Loadable<TopicsChunk>

export type TopicsChunks = ReadonlyMap<TopicTree['fullPath'], ReadonlyNonEmptyArray<LoadableTopicsChunk>>
